import { getAnalyticsId } from '@shared/core/analytics/segment/getAnalyticsId';
import { NR_ATTR_ANALYTICS_ID } from '@shared/utils/logger';
import { withWindow } from '@shared/utils/withWindow';
import { config } from '@static/js/env.config';

export const initNewRelic = () => {
  withWindow(window => {
    const { newrelic, buildNumber } = window;

    if (newrelic) {
      newrelic.setCustomAttribute('buildNumber', buildNumber);
      newrelic.setCustomAttribute('env', config.joyEnvironment);
      newrelic.setCustomAttribute(NR_ATTR_ANALYTICS_ID, getAnalyticsId());
      newrelic.addRelease('joy-web', buildNumber);
    }
  });
};
